module.exports = __webpack_public_path__ + "static/media/CodeOfConduct.4d131b54.md";